export default __webpack_public_path__ + "static/screenapp-for-virtual-learning-00fe853bd7762256df599a2eda2f9574.png";